import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toast";
//import * as auth from "../Auth";
import axios from "axios";
import ScaleLoader from "react-spinners/ScaleLoader";
import { useTranslation, withTranslation } from "react-i18next";
import styled from "styled-components";
import Uploady, { useItemProgressListener } from "@rpldy/uploady";
import { getMockSenderEnhancer } from "@rpldy/mock-sender";
import UploadButton from "@rpldy/upload-button";
import UploadPreview from "@rpldy/upload-preview";
import ImageUploader from "react-images-upload";
import "./style.css";
import {
  CreditCardIcon,
  KeyIcon,
  UserCircleIcon,
  UserGroupIcon,
  ViewGridAddIcon,
} from "@heroicons/react/outline";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;

function EditForm() {
  const { t } = useTranslation("common");
  const navigation = [
    { name: "Account", href: "#", icon: UserCircleIcon, current: true },
    { name: "Password", href: "#", icon: KeyIcon, current: false },
    { name: "Plan & Billing", href: "#", icon: CreditCardIcon, current: false },
    { name: "Team", href: "#", icon: UserGroupIcon, current: false },
    { name: "Integrations", href: "#", icon: ViewGridAddIcon, current: false },
  ];
  const mockSenderEnhancer = getMockSenderEnhancer();

  const [user, setUser] = useState([]);
  const [loading, setloading] = useState("false");
  //const showSuccess = () => toast.success("Message sent successfully!");
  const [images, setImages] = React.useState([]);
  const maxNumber = 69;

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };
  const [pic, setPic] = useState("");

  const removePic = () => {
    setPic("");
  };
  useEffect(() => {
    const fetchData = async () => {
      setloading(true);
      var lien = window.location.href;

      const var2 = lien.split("/");

      var var4 = var2[2].split(":");

      var config = {
        headers: {
          Authorization: token,
        },
      };
      const result = await axios
        .get(
          `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/InfosColleguesIPBXV3API?compte=${compte}&poste=${poste}`,
          config
        )
        .then((res) => {
          setUser(res.data.collegues[0]);
          setloading(false);
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            console.log("AXIOS ERROR: ", err);
          }
        });
    };

    fetchData();
  }, []);
  const showCustom = () =>
    toast(t("vtr.mdp"), {
      backgroundColor: "#27d0b2",
      color: "#ffffff",
    });
  const showCustomwarning = () =>
    toast(t("warning.photo.extension"), {
      backgroundColor: "#ffc241",
      color: "#ffffff",
    });

  const saveUser = (values, setStatus, setSubmitting) => {
    setloading(true);
    const updatedUser = Object.assign(user, values);

    setTimeout(() => {
      setloading(false);

      var lien = window.location.href;

      const var2 = lien.split("/");

      var var4 = var2[2].split(":");

      var data = new FormData();
      data.append("image", selectedFile);
      data.append("compte", compte);
      data.append("poste", poste);
      data.append("nom", values.nom);
      data.append("compagnie", values.compagnie);
      data.append("departement", values.departement);
      data.append("adresse_mail", values.adresse_mail);
      data.append("tel_mobil", values.tel_mobil);
      data.append("adresse", values.adresse);

      var config = {
        method: "post",
        url: `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/EditProfilIPBXV3APIpost`,
        headers: {
          Authorization: token,
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
          setloading(false);
          if (response.data.image == "KO") {
            setPreview("");
            showCustom();
            showCustomwarning();
          }
        })
        .catch(function (error) {
          if (error == "Error: Request failed with status code 401") {
            localStorage.clear();
            var link = "/";

            window.location.replace(link);
          } else {
            setloading(false);
            setSubmitting(false);
            setStatus(error);
            toast.error("probléme");
          }
        });
    }, 1000);
  };

  const initialValue = {
    //pic: user.photo_poste_interne,
    // image: user.photo_poste_interne,
    nom: user.nom,
    compagnie: user.compagnie,
    tel_mobil: user.tel_mobil,
    adresse_mail: user.adresse_mail,
    adresse: user.adresse,
    departement: user.departement,
  };

  const Schema = Yup.object().shape({
    // pic: Yup.string(),
    // nom: Yup.string().required("Saisissez votre prénom et votre nom"),
    // compagnie: Yup.string(),
    // tel_mobil: Yup.string().required("Saisissez votre numéro de Téléphone"),
    // adresse_mail: Yup.string()
    //   .email("entre un émail ")
    //   .required("Saisissez votre Email"),
    // adresse: Yup.string(),
  });
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "text-gray-300";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };
  const formik = useFormik({
    initialValues: initialValue,
    enableReinitialize: true,
    validationSchema: Schema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      //  console.log(values);
      saveUser(values, setStatus, setSubmitting);
    },
  });

  const [selectedFile, setselectedFile] = useState(null);
  const [preview, setPreview] = useState("");
  const onChangeHandler = (event) => {
    setselectedFile(event.target.files[0]);
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onloadend = () => {
      setPreview(reader.result);
    };
  };

  useEffect(() => {}, [preview]);
  if (loading == false) {
    return (
      <div className="min-h-screen w-full bg-white flex dark:bg-gray-700 bg-gray-200">
        <div className="flex-1 flex  justify-center  mt-4 dark:bg-gray-800 bg-white shadow sm:rounded-md sm:overflow-hidden mr-8">
          <ToastContainer delay={9000} position={"top-right"} />
          {/* <input type="file" name="file" onChange={onChangeHandler} />
          <img src={preview} alt={"preview"} style={{ objectFit: "cover" }} /> */}
          {/* <button
            type="button"
            class="btn btn-success btn-block"
            onClick={onClickHandler}
          >
            Upload
          </button> */}

          <form
            className="space-y-8  divide-y divide-gray-200  h-full"
            onSubmit={formik.handleSubmit}
          >
            {/* <input onChange={(e) => changeFile(e)} type="file" />
            <img id="blah" src="#" alt="your image" /> */}
            {loading && loading}
            {/* begin::Header */}
            <div className="space-y-8 divide-y divide-gray-200 sm:space-y-5">
              <div>
                <div>
                  <h2 className="dark:text-white pb-8 pt-4 text-lg leading-6 mt-2 my-2 mx-2 font-medium text-gray-900">
                    {t("editprofil")}
                  </h2>

                  <p className="dark:text-gray-400 mt-2 my-2 mx-2  max-w-2xl text-sm text-gray-500">
                    {t("profil.warning")}
                  </p>
                </div>

                <div className="mt-6 sm:mt-5 space-y-6 sm:space-y-5">
                  <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 dark:border-gray-500 sm:pt-5">
                    <label
                      htmlFor="photo"
                      className="dark:text-white pl-2 block text-sm font-medium text-gray-700"
                    >
                      Photo
                    </label>
                    <div className="mt-1 sm:mt-0 sm:col-span-2">
                      <div className="flex items-center">
                        <span className="h-16 w-16 rounded-full overflow-hidden bg-gray-100">
                          {preview == "" ? (
                            <div>
                              {user.photo_poste_interne ? (
                                <img
                                  src={user.lien_photo_poste_interne}
                                  //  alt={"preview"}
                                  className="h-full w-full"
                                />
                              ) : (
                                <svg
                                  className="h-full w-full text-gray-300"
                                  fill="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                                </svg>
                              )}{" "}
                            </div>
                          ) : (
                            <img
                              src={preview}
                              //  alt={"preview"}
                              className="h-full w-full"
                            />
                          )}
                        </span>
                        <div class="fileinputs">
                          <input
                            type="file"
                            class="file"
                            onChange={onChangeHandler}
                            name="image"
                            // {...formik.getFieldProps("image")}
                          />
                          <div class="fakefile ml-5 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            {t("edit.profile.image")}
                          </div>
                        </div>
                        {/* <input
                          type="file"
                          name="file"
                          style={{
                            opacity: "0",
                            // width: "20px",
                          }}
                          onChange={onChangeHandler}
                          // className="ml-5 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        />{" "}
                        <div className="ml-5 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                          {" "}
                          Modifier photo de profil
                        </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 dark:border-gray-500 sm:pt-5">
                    <label
                      htmlFor="username"
                      className="dark:text-white block ml-3 text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                    >
                      {t("departement")}
                    </label>
                    <div className="mt-1 sm:mt-0 sm:col-span-2">
                      <div className="mt-1">
                        <input
                          type="text"
                          placeholder="Company name"
                          className={`mt-1 px-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 dark:border-gray-500 border border-gray-300  focus:border-transparent  focus:ring-green-300 rounded-md w-4/4 h-10 rounded-md`}
                          name="departement"
                          {...formik.getFieldProps("departement")}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t dark:border-gray-500 sm:border-gray-200 sm:pt-5">
                    <label
                      htmlFor="username"
                      className="dark:text-white block ml-3 text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                    >
                      Email
                    </label>
                    <div className="mt-1 sm:mt-0 sm:col-span-2">
                      <div className="mt-1">
                        <input
                          type="email"
                          placeholder="Email"
                          className={`mt-1 px-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 border dark:border-gray-500 border-gray-300  focus:border-transparent w-4/4 h-10 focus:ring-green-300  block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ${getInputClasses(
                            "email"
                          )}`}
                          name="adresse_mail"
                          {...formik.getFieldProps("adresse_mail")}
                        />

                        {formik.touched.adresse_mail &&
                        formik.errors.adresse_mail ? (
                          <div className="invalid-feedback display-block">
                            {formik.errors.adresse_mail}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start dark:border-gray-500 sm:border-t sm:border-gray-200 sm:pt-5">
                    <label
                      htmlFor="username"
                      className="dark:text-white block ml-3 text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                    >
                      {t("Nom.contact.table")}
                    </label>
                    <div className="mt-1 sm:mt-0 sm:col-span-2">
                      <div className="mt-1">
                        <input
                          type="text"
                          placeholder="First name"
                          className={`mt-1 px-2 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 border border-gray-300  focus:border-transparent  focus:ring-green-300 rounded-md w-4/4 h-10 rounded-md ${getInputClasses(
                            "firstname"
                          )}`}
                          name="nom"
                          {...formik.getFieldProps("nom")}
                        />
                        {formik.touched.nom && formik.errors.nom ? (
                          <div className="text-red invalid-feedback">
                            {formik.errors.nom}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start dark:border-gray-500 sm:border-t sm:border-gray-200 sm:pt-5">
                    <label
                      htmlFor="username"
                      className="dark:text-white block ml-3 text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                    >
                      {t("Adresse")}
                    </label>
                    <div className="mt-1 sm:mt-0 sm:col-span-2">
                      <div className="mt-1">
                        <input
                          type="text"
                          // placeholder="https://keenthemes.com"
                          className={`mt-1 px-2 dark:border-gray-500 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 border border-gray-300  focus:border-transparent  focus:ring-green-300 rounded-md w-4/4 h-10 rounded-md`}
                          name="adresse"
                          {...formik.getFieldProps("adresse")}
                        />

                        {formik.touched.adresse && formik.errors.adresse ? (
                          <div className="invalid-feedback display-block">
                            {formik.errors.adresse}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="sm:grid dark:border-gray-500 sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                    <label
                      htmlFor="username"
                      className="dark:text-white block ml-3 text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                    >
                      {t("tel.contact.table")}
                    </label>
                    <div className="mt-1 sm:mt-0 sm:col-span-2">
                      <div className="mt-1">
                        <input
                          type="text"
                          placeholder="+(216)11-111-111"
                          className={`mt-1 px-2 dark:border-gray-500 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 border border-gray-300  focus:border-transparent  focus:ring-green-300 rounded-md w-4/4 h-10 rounded-md ${getInputClasses(
                            "phone"
                          )}`}
                          name="tel_mobil"
                          {...formik.getFieldProps("tel_mobil")}
                        />
                      </div>
                      {formik.touchedtel_mobil && formik.errors.tel_mobil ? (
                        <div className="invalid-feedback display-block">
                          {formik.errors.tel_mobil}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className="px-4 py-3  text-center sm:px-6">
                {!formik.dirty ? (
                  <button
                    type="submit"
                    className="dark:bg-gray-700 dark:text-gray-500 inline-flex justify-center py-3 px-7 dark:border-gray-500  border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-200"
                    // disabled={
                    //   formik.isSubmitting || (formik.touched && !formik.isValid)
                    // }
                    disabled={!formik.dirty}
                  >
                    {t("save")}
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="inline-flex justify-center py-3 px-7 dark:border-gray-500 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                    // disabled={
                    //   formik.isSubmitting || (formik.touched && !formik.isValid)
                    // }
                    disabled={!formik.dirty}
                  >
                    {t("save")}
                    {formik.isSubmitting}
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  } else {
    return (
      <div className="flex justify-center pt-4">
        {/* begin::Header */}
        <div className="space-y-8 divide-y divide-gray-200 sm:space-y-5">
          <div>
            <div>
              <h2 className="dark:text-white pb-8 pt-4 text-lg leading-6 mt-2 my-2 mx-2 font-medium text-gray-900">
                {t("editprofil")}
              </h2>
              <p className="mt-2 my-2 mx-2  max-w-2xl text-sm text-gray-500">
                {t("profil.warning")}
              </p>
            </div>
            <div className="flex flex-wrap justify-center  mt-64">
              <ScaleLoader
                color="#109669"
                loading={loading}
                size={50}
                width={4}
                height={68}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation("common")(EditForm);
